(function () {
  'use strict';

  var timer = null;
  var pendingOpen = false;

  function getDrawer() {
    return document.querySelector('hdt-cart-drawer');
  }

  // Foxify's add-to-cart fires these. Kalles only listens for
  // cart:update / cart:reload, so it never hears them.
  function onFoxifyCartChange() {
    if (!getDrawer()) return;
    pendingOpen = true;
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.dispatchEvent(new CustomEvent('cart:reload'));
    }, 60);
  }

  document.addEventListener('cart:refresh', onFoxifyCartChange);
  document.addEventListener('cart:build', onFoxifyCartChange);

  // Kalles fires this once the drawer has finished re-rendering.
  document.addEventListener('cart:drawer:render', function () {
    if (!pendingOpen) return;
    pendingOpen = false;

    var settings = window.themeHDN && window.themeHDN.settings;
    if (!settings || settings.actionAfterATC !== 'open_cart_drawer') return;
    if (settings.pageType === 'cart') return;

    var el = getDrawer();
    if (el && typeof el.open === 'function') el.open();
  });
})();
